import { Permission } from '@/lib/permissions/v1'
import { assetParamKey, Route } from '@/composables/route'

export const setRouteQueries = async (route: Route) => {
    await route.addSortItem({
        column: 'name',
        direction: 'asc',
    })

    route.groupBy.value = 'category'

    route.setLimit(999999)
}

export enum CompanyAssetRouteName {
    Index = 'company.assets.index',
    Create = 'company.assets.create',
    Edit = 'company.assets.edit',
    Show = 'company.assets.show',
    Logs = 'company.assets.logs',
    LogDetails = 'company.assets.logs.details',
    Secrets = 'company.assets.secrets',
    SecretDetails = 'company.assets.secrets.details',
    SecretCreate = 'company.assets.secrets.create',
    SecretEdit = 'company.assets.secrets.edit',
    SecretLogs = 'company.assets.secrets.logs',
    SecretLogDetails = 'company.assets.secrets.logs.details',
}

export default {
    path: 'assets',
    component: () => import('@/views/company/asset/Layout.vue'),
    children: [
        {
            path: '',
            name: CompanyAssetRouteName.Index,
            component: () => import('@/views/company/asset/Index.vue'),
            meta: {
                label: 'Company Assets',
                auth: true,
                permission: Permission.CompanyAssetViewAny,
            },
        },
        {
            path: 'create',
            name: CompanyAssetRouteName.Create,
            component: () => import('@/views/company/asset/Create.vue'),
            meta: {
                label: 'Create Asset',
                auth: true,
                permission: Permission.CompanyAssetCreate,
            },
        },
        {
            path: `:${assetParamKey}/edit`,
            name: CompanyAssetRouteName.Edit,
            component: () => import('@/views/company/asset/Edit.vue'),
            meta: {
                label: 'Edit Asset',
                auth: true,
                permission: Permission.CompanyAssetUpdate,
            },
        },
        {
            path: `:${assetParamKey}`,
            name: CompanyAssetRouteName.Show,
            component: () => import('@/views/company/asset/Index.vue'),
            meta: {
                label: 'Asset Details',
                auth: true,
                permission: Permission.CompanyAssetView,
            },
        },
        {
            path: `:${assetParamKey}/logs`,
            name: CompanyAssetRouteName.Logs,
            component: () => import('@/views/company/asset/Index.vue'),
            meta: {
                label: 'Asset Logs',
                auth: true,
                permission: Permission.EventViewAny,
            },
            children: [
                {
                    path: ':logId',
                    name: CompanyAssetRouteName.LogDetails,
                    component: () => import('@/views/company/asset/Index.vue'),
                    meta: {
                        label: 'Log Details',
                        auth: true,
                        permission: Permission.EventView,
                    },
                },
            ],
        },
        {
            path: `:${assetParamKey}/secrets`,
            name: CompanyAssetRouteName.Secrets,
            component: () => import('@/views/company/asset/Index.vue'),
            meta: {
                label: 'Asset Secrets',
                auth: true,
                permission: Permission.SecretView,
            },
            children: [
                {
                    path: ':secretUuid',
                    name: CompanyAssetRouteName.SecretDetails,
                    component: () => import('@/views/company/asset/Index.vue'),
                    meta: {
                        label: 'Secret Details',
                        auth: true,
                        permission: Permission.SecretView,
                    },
                },
                {
                    path: 'create',
                    name: CompanyAssetRouteName.SecretCreate,
                    component: () => import('@/views/company/asset/Index.vue'),
                    meta: {
                        label: 'Create Company Asset Secret',
                        auth: true,
                        permission: Permission.SecretCreate,
                    },
                },
                {
                    path: ':secretUuid/edit',
                    name: CompanyAssetRouteName.SecretEdit,
                    component: () => import('@/views/company/asset/Index.vue'),
                    meta: {
                        label: 'Edit Company Asset Secret',
                        auth: true,
                        permission: Permission.SecretUpdate,
                    },
                },
                {
                    path: ':secretUuid/logs',
                    name: CompanyAssetRouteName.SecretLogs,
                    component: () => import('@/views/company/asset/Index.vue'),
                    meta: {
                        label: 'Secret Logs',
                        auth: true,
                        permission: Permission.EventViewAny,
                    },
                    children: [
                        {
                            path: ':logId/details',
                            name: CompanyAssetRouteName.SecretLogDetails,
                            component: () => import('@/views/company/asset/Index.vue'),
                            meta: {
                                label: 'Log Details',
                                auth: true,
                                permission: Permission.EventView,
                            },
                        },
                    ],
                },
            ],
        },
    ],
}
